"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterResult = void 0;
var LetterResult = /** @class */ (function () {
    function LetterResult() {
        this.properLetters = [];
        this.chosenLetters = [];
        this.numberCorrect = 0;
        this.totalLetters = 0;
    }
    LetterResult.prototype.addInputs = function (properLetters, chosenLetters) {
        console.debug("Adding inputs to practice letter result: " + properLetters + " -- " + chosenLetters);
        var numberCorrect = 0;
        for (var i = 0; i < chosenLetters.length; i++) {
            if (i >= properLetters.length) {
                // For the case where they select more letters than were shown.
                break;
            }
            var selectedLetter = chosenLetters[i];
            var properLetter = properLetters[i];
            if (selectedLetter === properLetter) {
                numberCorrect++;
            }
        }
        this.properLetters.push(properLetters);
        this.chosenLetters.push(chosenLetters);
        this.numberCorrect += numberCorrect;
        this.totalLetters += chosenLetters.length;
    };
    return LetterResult;
}());
exports.LetterResult = LetterResult;
